import { ScrollView, StyleSheet, View } from "react-native";
import { useTranslation } from "react-i18next";

import { WorkspaceHeader } from "../components/chatNewInterface/interfaceComponents/workspaceHeader/WorkspaceHeader";
import { UserData } from "../containers/settings/ChatSettings/UserData";
import { ChatIntegration } from "../containers/settings/ChatSettings/ChatIntegration";
import CompanionLayout from "../layouts/CompanionLayout";
import { semanticColors } from "../styles/design-system";

const ChatSettings = () => {
  const { t } = useTranslation();
  return (
    <CompanionLayout>
      <View style={styles.container}>
        <WorkspaceHeader title={t("Settings")} />
        <ScrollView style={styles.scrollView}>
          <View style={styles.settingsSections}>
            <UserData />
            <ChatIntegration />
          </View>
        </ScrollView>
      </View>
    </CompanionLayout>
  );
};

const styles = StyleSheet.create({
  container: {
    height: "100%",
    display: "flex",
    maxHeight: "100vh",
    overflow: "hidden",
    backgroundColor: semanticColors.surface.light,
  },
  scrollView: {
    flex: 1,
  },
  settingsSections: {
    maxWidth: 900,
    marginHorizontal: "auto",
    display: "flex",
    gap: 32,
    padding: 24,
  },
});

export default ChatSettings;
